import { addDays, parseISO, set } from 'date-fns'

// 오늘의 학습 하루 기준: 당일 새벽 2시 ~ 다음날 새벽 2시 - 해당 정책 관련 유틸은 모두 이곳에서 관리
export const DAILY_LEARNING_DAY_START_HOUR = 2 as const

/** 학습일 시작 시각 (해당 날짜 새벽 2시) */
export const getLearningDayStart = (dateString: string): Date =>
  set(parseISO(dateString), {
    hours: DAILY_LEARNING_DAY_START_HOUR,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  })

/** 현재 기준 다음 학습일 시작 시각 반환 */
export const getNextLearningDayStart = (now = new Date()): Date => {
  const todayLearningDayStart = new Date(now)
  todayLearningDayStart.setHours(DAILY_LEARNING_DAY_START_HOUR, 0, 0, 0)
  return now >= todayLearningDayStart ? addDays(todayLearningDayStart, 1) : todayLearningDayStart
}
